import React, { useRef } from 'react'

import classnames from 'classnames/bind'
import Link from 'components/shared/Link'
import Img from 'components/shared/Image/Img'
import { Text } from 'components/typo'
import useComponentSize from '@rehooks/component-size'
import { gsap } from 'gsap'
import { useWindowSize } from 'react-use'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ResourceNavigation = ({ className, iconLinks, sections }) => {
  const componentRef = useRef()
  const { height } = useComponentSize(componentRef)
  const { height: windowHeight } = useWindowSize()


  useIsomorphicLayoutEffect(() => {
    gsap.set(componentRef.current, {
      top: height > windowHeight ? `${windowHeight - height - 84}px` : '120px',
    })
  }, [height, windowHeight])

  return (
    <div ref={componentRef} className={cx(className, css.ResourceNavigation)}>
      <div className={css.iconLinks}>
        {iconLinks.map(({ icon, link }) => {
          const formattedIcon = { ...icon, media: icon.media.data.attributes }
          return (
            <Link className={cx(css.link, css.iconLink)} {...link}>
              <div className={css.iconWrapper}>
                <Img className={css.icon} {...formattedIcon} />
              </div>
              <Text tag="span" size="small" theme="gray">
                {link.text}
              </Text>
            </Link>
          )
         
        })}
      </div>
      <div className={css.sections}>
        {sections.map((section) => (
          <div className={css.section}>
            {section.title && (
              <Text size="small" theme="purple" className={css.title}>
                {section.title}
              </Text>
            )}
            {section.links &&
              section.links.map((link) => (
                <Link className={css.link} {...link}>
                  <Text tag="span" size="small" theme="gray">
                    {link.text}
                  </Text>
                </Link>
              ))}
          </div>
        ))}
      </div>
    </div>
  )
}

ResourceNavigation.defaultProps = {}

export default ResourceNavigation
